import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import {Link} from "react-router-dom";
import { getAthletes, linkAthleteToEvent, getAthletesByEvent } from "../../../db";

const NewAthlete = ({ onClose, eventId }) => {

    const { t } = useTranslation();
    const [availableAthletes, setAvailableAthletes] = useState([]);

    useEffect(() => {
        let isMounted = true;

        const fetchAthletes = async () => {
            if (!eventId) return; // 🔒 Safety check for undefined/null

            try {
                const allAthletes = await getAthletes();
                const linkedAthletes = await getAthletesByEvent(eventId);
                const linkedIds = linkedAthletes.map(a => a.id);
                const filtered = allAthletes.filter(a => !linkedIds.includes(a.id));

                setAvailableAthletes(filtered);
            } catch (error) {
                console.error("Failed to load athletes:", error);
            }
        };

        fetchAthletes();
    }, [eventId]);

    const handleSelectAthlete = async (athleteId) => {
        await linkAthleteToEvent(athleteId, eventId); // 👈 assumes such function exists
        onClose(); // close the modal
    };

    return (
        <div className="fixed inset-0 z-30 flex items-center justify-center">
            <div className="bg-black opacity-60 absolute inset-0" onClick={onClose}></div>
            <div className="bg-white p-10 relative w-[90rem] max-w-[90svw] max-h-[90svh] overflow-y-auto">
               <button onClick={onClose} className="absolute right-0 top-0 p-2 bg-[var(--light-color)] text-[var(--dark-color)]">
                <IconX className="w-6 h-auto" />
               </button>
                <div>
                    {availableAthletes.length > 0 ? (
                        <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-xs px-2">
                            {availableAthletes.map((athlete) => (
                                <button
                                    key={athlete.id}
                                    className="button-secondary flex-col !items-start justify-between"
                                    onClick={() => handleSelectAthlete(athlete.id)}
                                >
                                    <span>{athlete.nickname || `${athlete.firstname} ${athlete.lastname}`}</span>
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div>
                            <p>{t("event.athletes.noFoundAthlete")}</p>
                            <div className="px-2 mt-6 text-xs">
                                <Link to="/athletes/new" className="button-primary">{t("event.athletes.createNew")}</Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewAthlete;